<template>
  <div class="padded">

    <edit-pane v-if="!hidePanel" ref="cd" :title="form.name"
    :is-edit="editModeState" :prefix="prefix" :show-edit-button="isAdding || profile().login === form.login || isSuper()"
    :parent-managed="parentManaged"
    @save="onSave" @cancel="onCancel" @edit="onEdit" @add="onAdd"
    :show-background="!isAdding"  />

    <el-form ref="contactDetailsForm" label-width="90px">

      <el-tabs type="border-card"
        :active-name="currentTab"
        :before-leave="validateForm"
        @tab-click="tabChanged">
        <el-tab-pane name="contact" label="Contact">

          <el-row>
            <el-form-item label="Name" required>
              <el-input name="name" required v-model="form.name" :disabled="disabled" placeholder="Full Name" />
            </el-form-item>

            <el-form-item label="Short Name">
              <el-input name="shortName" v-model="form.shortName" :disabled="disabled" placeholder="Short Name" />
            </el-form-item>

            <el-form-item label="Job Title">
              <el-input name="jobTitle" v-model="form.jobTitle" :disabled="disabled" />
            </el-form-item>

          </el-row>

          <el-row>
            <el-form-item label="Phone">
              <el-input type="phone" name="phone" v-model="form.phone" :disabled="disabled" />
            </el-form-item>
            <el-form-item label="E-mail">
              <el-input type="email" name="email" v-model="form.email" :disabled="disabled" />
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="12">
              <check-box label="Upload Alerts" v-model="form.sendUploadAlerts" :disabled="disabled && isManager()" />
            </el-col>

            <el-col :span="12">
              <check-box label="Approval Alerts" v-model="form.sendApprovalAlerts" :disabled="disabled && isManager()" />
            </el-col>
          </el-row>

          <password-dialog class="text-right" v-model="form" change :new-psw="isAdding" :disabled="disabled" />

        </el-tab-pane>





        <el-tab-pane name="systemDetails" v-if="isSuper() && isTowerCo()" label="System Details">
          <el-row :gutter="12">

            <el-form label-position="top" :inline="true">
              <el-row>
              <el-col :span="24">
                <switch-input
                  label="Enabled?"
                  on-text="Enabled"
                  off-text="Disabled"
                  v-model="form.enabled"
                  :disabled="disabled" />

                <text-input
                label="Login ID"
                 v-model="form.login"
                 placeholder="Login Id"
                :disabled="disabled" />

              </el-col>
            </el-row>

              <section  v-if="form.orgCategory === 'Tower Company'">
                <el-row :gutter="5.28">

                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                  <select-input :list="roles" v-model="form.defaultView" label="Default View"  :disabled="disabled" />
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="12">

                  <el-transfer
                      v-if="!disabled"
                      v-model="formUserRoles"
                      :titles="['All Roles', 'User Roles']"
                      :data="roles"
                      @change="changeUserRoles" />

                  <el-form-item  v-else label="User Roles">
                    <span  v-for="(role, i) in roles" :key="i">
                      <el-tag v-if="formUserRoles.includes(role.value)" :type="role.type">
                        {{role.label}}
                      </el-tag>&nbsp;
                    </span>
                  </el-form-item>

                </el-col>

              </el-row>

              <el-row :gutter="5.28">

                <el-col :xs="24" :sm="24" :md="12" :lg="6">

                  <switch-input label="View Only" v-model="form.viewer" :disabled="disabled" />

                  <el-alert
                    title="View Only"
                    type="info"
                    description="View Only can't add, edit or delete anything. Only can create tickets."
                    show-icon
                    :closable="false" />
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="6">

                  <switch-input label="Approver" v-model="form.approver" :disabled="disabled" />

                  <el-alert
                     title="Requests Module Only"
                     type="success"
                     description="Approver for Requests (can approve and send approval email)"
                     show-icon
                     :closable="false" />

                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="6">

                  <switch-input label="Manager" v-model="form.manager" :disabled="disabled" />

                  <el-alert
                    title="Manager"
                    type="warning"
                    description="Manager can add, edit and delete according to role(s)"
                    show-icon
                    :closable="false" />
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="6">

                  <switch-input label="Super" v-model="form.super" :disabled="disabled" />

                  <el-alert
                    title="Super User"
                    type="error"
                    description="Super User can create users and delete anything even sites."
                    show-icon
                    :closable="false" />
                </el-col>
              </el-row>
            </section>

          </el-form>

        </el-row>

      </el-tab-pane>

      <el-tab-pane name="remarks" v-if="isManager() || isSuper()" label="Remarks">

          <html-input v-model="form.remarks"
            label="Remarks"
            :show-empty-message="true"
            :disabled="disabled" />

      </el-tab-pane>

    </el-tabs>
  </el-form>

  <small v-if="!isAdding" class="text-muted">ID <b>{{form.organisation_id + '-' + form.id + '-' + form.created_at}}</b></small>
</div>

</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'
import PasswordDialog from '@/components/login/PasswordDialog'

export default {

  mixins: [SiteMixins],


  components: {
    PasswordDialog
  },



  props: {
    rowData: {
      type: Object,
      required: true
    },

    prefix: {
      type: String,
      default: 'Contact'
    },

    orgId: {
      type: Number
    },

    isDisabled: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'contacts-table'
    },

    adding: {
      type: Boolean,
      default: false
    },

    hidePanel: {
      type: Boolean,
      default: false
    },

    parentManaged: {
      type: Boolean,
      default: true
    }

  },



  methods: {

    changeUserRoles (roles) {
      let userRole = ''

      if (roles.length > 0) {

         for (let s in roles) {
             userRole += (s > 0 ? '|' + roles[s] : roles[s])
           }

         } else {
           userRole = this.formUserRoles[0]
         }

     this.form.userRole = userRole
    },



    resetData () {
      this.form.id = null
      this.form.name = null
      this.form.jobTitle = null
      this.form.phone = null
      this.form.email = null
      this.form.enabled = false
      this.form.login = null
      this.form.sendUploadAlerts = false
      this.form.sendApprovalAlerts = false
    },



    success (response) {
      this.initialForm = { ...this.form }
      this.$events.emit(this.tableRef + '-refresh-table')
    },



    onCancel () {
      this.disabled = true
      if (this.parentManaged) this.editModeState = false

      // Blur the active element if it belongs to this form before resetting.
      // Rationale: after a blocked tab-switch, the browser can latch an
      // invalid required <input> into a visual state where a subsequent
      // programmatic value assignment (via Element UI's nativeInputValue
      // watcher) is not repainted. Releasing focus clears the latch.
      // See .context/plans/contact-detail-stale-input-plan.md.
      const formEl = this.$refs.contactDetailsForm && this.$refs.contactDetailsForm.$el
      const active = typeof document !== 'undefined' ? document.activeElement : null
      if (formEl && active && formEl.contains(active) && typeof active.blur === 'function') {
        active.blur()
      }

      this.$nextTick(() => {
        this.form = { ...this.initialForm }
      })
    },



    onEdit () {
      this.disabled = false
      if (this.parentManaged) this.editModeState = true
    },



    onAdd () {
      this.disabled = false
      this.isAdding = true

      var id = this.form.organisation_id
      this.form = this.getTableStruct('contacts')
      this.form.organisation_id = id
      if (this.parentManaged) this.editModeState = true
    },


    validateForm () {
      const form = this.$refs.contactDetailsForm.$el
      if (!form.checkValidity()) {
        form.reportValidity()
        return false
      }
      return true
    },

    onSave (orgId) {
      if (!this.validateForm()) {
        if (this.parentManaged) this.editModeState = true
        return
      }

      if (orgId && this.isAdding) {
        this.org_id = orgId
        this.form.organisation_id = this.org_id
      }

      if (this.form.sendUploadAlerts || this.form.sendApprovalAlerts) {

        if (this.isNull(this.form.sendUploadAlerts)) {
          this.form.sendUploadAlerts = false
        }

        if (this.isNull(this.form.sendApprovalAlerts)) {
          this.form.sendApprovalAlerts = false
        }

      }

      this.disabled = this.isAdding ? false : true
      if (this.parentManaged) this.editModeState = false
      this.saveForm(this, '/contacts', this.form.id, this.form, this.form.name, this.success)
    },


    tabChanged (pane) {
      this.currentTab = pane.name
    },



    onClose () {
      this.resetData()
    }

  },



  data () {
    const form = this.adding ? this.getTableStruct('contacts') : this.rowData

    let formUserRoles = []
    if (form.userRole) {
      formUserRoles = form.userRole.trim().split('|')
    }

    return {
      disabled: this.isBoolean(this.isDisabled) ? this.isDisabled : true,
      emailDisabled: !(this.adding && this.isManager() || this.profile().login === this.rowData.login),
      isAdding: this.adding,
      formUserRoles: formUserRoles,
      roles: [
       { key: 'project', label: 'Project', value: 'project', type: 'primary' },
       { key: 'property', label: 'Property', value: 'property', type: 'secondary' },
       { key: 'maintenance', label: 'Maintenance', value: 'maintenance', type: 'warning' },
       { key: 'finance', label: 'Finance', value: 'finance', type: 'success' },
       { key: 'admin', label: 'Admin', value: 'admin', type: 'info' },
       { key: 'management', label: 'Management', value: 'management', type: 'primary' }
      ],
      org_id: (this.rowData.organisation_id ? this.rowData.organisation_id : this.orgId),
      form: form,
      initialForm: { ...form },
      editModeState: this.editMode,
      currentTab: 'contact'
    }
  },

  created () {

    if (this.isAdding) {
      this.disabled = false
      delete this.form.id
    }

    if (!this.form.organisation_id) {
      this.form.organisation_id = this.org_id
    }

  }

}

</script>
